<template>
	<div style="background: var(--grey-2);margin-bottom:5px;padding:5px;" @click="this.show = !this.show" title="Klicka för mer info, webbadress och telefonnummer">
		<div v-if="this.reseller" class="flexcenter link" style="align-items:start;">

			<div style="flex-grow:1;">
				<b style="font-size:110%;"> {{ reseller.name }}</b> <br /> <b style="color:grey;font-size:90%;">{{
					this.reseller.postaddress }}, {{ this.reseller.postnumber }} {{ this.reseller.city }} {{ this.country }}</b>
				<div v-if="this.reseller?.companyDescription" style="margin-top:10px;font-size:80%;font-weight:bold;">
					{{ this.reseller?.companyDescription }}
				</div>

			</div>
			<div class="flexcenter">
				<div class="type-badge" v-if="this.reseller?.resellerType?.includes('B')">BIL</div>
				<div class="type-badge" v-if="this.reseller?.resellerType?.includes('C')">CYKEL</div>
				<div class="type-badge" v-if="this.reseller?.resellerType?.includes('M')">MC</div>


				<Icon v-if="!this" :fileName="this.show ? 'w3_chevron_up_light' : 'w3_chevron_down_light'"
					style="width:20px;height:20px;margin-right:10px;margin-top:5px;" />
			</div>

		</div>

		<div v-if="this.show" style="margin-top:10px;font-size:80%;">
			<div class="flexcenter">
				<div  v-if="this.reseller.telephone && this.reseller.telephone?.length > 3" class="flexcenter" style="background:var(--grey-4);padding:5px;border-radius: 5px;;">
					<Circle fileName="w3_phone_dark" size="20px" color="" style="margin-right:0px;" />
					<b><a :href=" 'tel:' + this.reseller.telephone">{{ this.reseller.telephone }}</a></b>
				</div>

				<div v-if="this.reseller.url && this.reseller.url.length > 3" class="flexcenter" style="background:var(--grey-4);padding:5px;border-radius: 5px;;">
					<Circle fileName="w3_link_dark" size="20px" color="" style="margin-right:0px;" />
					<b><a :href="this.url" target="_blank" style="">{{ this.reseller.url }}</a></b>


				</div>
			</div>

			
		</div>



	</div>
</template>
<script>

//import { PRODUCT_STORE_ACTION } from '@/store/product-store';
//import EntityHeaderSort from "@/components/entity/EntityHeaderSort.vue";
//import listHelper from "@/helper/list-helper.js";
//import { logMixin } from "@/mixins/logMixin.js";

export default {
	name: "ResellerRow",
	components: {},
	mixins: [],
	props: {
		reseller:Object
	},
	data() {
		return {
			show: false
		};
	},
	computed: {


		url(){
			const url = this.reseller.url;

			if (url?.toLowerCase()?.startsWith("http")){

				return url;

			}

			return "http://" + url

		},
		country(){

			const country = this.reseller?.country?.toUpperCase();
			
			if (country == "SE" || country == ""){
				return "";
			}

			if (country == "NO"){
				return ", Norge"
			}

			if (country == "DK"){
				return ", Danmark"
			}

			return ", " + this.reseller?.country

			
		}

		//baseModel() {
		//	return this.$store.getters[STORE_GETTER.BASE_MODEL]
		//},


	},
	watch: {
		//filterInput: function (filter) {
		//	console.log("FP: watcher: ", filter);
		//}

		//"product.name": {
		//	handler() {
		//		this.product.meta.state = settings.STATE_UPDATED
		//	}, deep: true
		//},
	},
	methods: {
		// this.$store.commit(STORE_COMMIT.SET_PAGE_MENU_OPEN, false);
		//this.$store.dispatch({ type: PRODUCT_STORE_ACTION.GET_PRODUCT_LIST, data: { loginToken: this.$store.state.loginToken } });


	},
	created() {

	}
};
</script>

<style scoped>

div.type-badge{
	padding:5px;
	font-size:80%;
	border-radius: 3px;
	background:var(--grey-4);
	font-weight:bold;
}
</style>